import React, { useState } from 'react';

/**
 * Channel creation floating window (modal).
 */
const CreateChannelModal = ({ onClose, onCreate, onCreated }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;

    try {
      setSubmitting(true);
      setError(null);
      const channel = await onCreate(trimmed);
      onCreated(channel);
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" onMouseDown={onClose}>
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            <form onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">
                  <i className="bi bi-hash me-2" aria-hidden="true"></i>
                  New channel
                </h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
              </div>
              <div className="modal-body">
                {error && (
                  <div className="alert alert-danger d-flex align-items-center gap-2" role="alert">
                    <i className="bi bi-exclamation-octagon-fill" aria-hidden="true"></i>
                    {error}
                  </div>
                )}
                <div className="mb-1">
                  <label htmlFor="channel-name" className="form-label text-muted-gh">Channel name</label>
                  <div className="input-group">
                    <span className="input-group-text">#</span>
                    <input
                      id="channel-name"
                      type="text"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      disabled={submitting}
                      autoFocus
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-gh" onClick={onClose}>Cancel</button>
                <button type="submit" className="btn btn-gh-primary" disabled={submitting || !name.trim()}>
                  {submitting ? 'Creating...' : 'Create channel'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateChannelModal;
